export const ACCOUNT_REQUEST = 'ACCOUNTS_REQUEST';
export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE';
export const ACCOUNT_UPDATE_SUCCESS = 'ACCOUNT_UPDATE_SUCCESS';
export const ACCOUNT_PUT = 'ACCOUNT_PUT';
export const ACCOUNT_PUT_SUCCESS = 'ACCOUNT_PUT_SUCCESS';
export const ACCOUNT_CURRENT = 'ACCOUNT_CURRENT';
export const ACCOUNT_CURRENT_SUCCESS = 'ACCOUNT_CURRENT_SUCCESS';
export const ACCOUNT_COMPLETE_TUTORIAL = 'ACCOUNT_COMPLETE_TUTORIAL';
export const ACCOUNT_COMPLETE_TUTORIAL_SUCCESS =
  'ACCOUNT_COMPLETE_TUTORIAL_SUCCESS';
export const ACCOUNT_GET_INTEGRATIONS = 'ACCOUNT_GET_INTEGRATIONS';
export const ACCOUNT_GET_INTEGRATIONS_SUCCESS =
  'ACCOUNT_GET_INTEGRATIONS_SUCCESS';
